import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect, useMemo, useState } from "react";
import { EnvironmentContext } from "./environmentContext";
import { getGlobal } from "../util/getGlobal";
const theGlobal = getGlobal();
const EnvironmentContextProvider = ({ children, mobileMatchMedia = "(max-width: 480px)", }) => {
    const [viewportHeight, setViewportHeight] = useState(theGlobal.innerHeight);
    const [viewportWidth, setViewportWidth] = useState(theGlobal.innerWidth);
    const [devicePixelRatio, setDevicePixelRatio] = useState(theGlobal.devicePixelRatio);
    const [isMobile, setIsMobile] = useState(theGlobal.matchMedia?.(mobileMatchMedia).matches);
    const updateState = useCallback(() => {
        setViewportHeight(theGlobal.innerHeight);
        setViewportWidth(theGlobal.innerWidth);
        setDevicePixelRatio(theGlobal.devicePixelRatio);
        setIsMobile(theGlobal.matchMedia?.(mobileMatchMedia).matches);
    }, [mobileMatchMedia]);
    useEffect(() => {
        updateState();
        theGlobal.addEventListener("resize", updateState);
        return () => theGlobal.removeEventListener("resize", updateState);
    }, [mobileMatchMedia, updateState]);
    const value = useMemo(() => ({ isMobile, viewportHeight, viewportWidth, devicePixelRatio }), [isMobile, viewportHeight, viewportWidth, devicePixelRatio]);
    return _jsx(EnvironmentContext.Provider, { value: value, children: children });
};
export default EnvironmentContextProvider;
